$shm_hitalama_map_widget_float_table_follower $mol_follower
	zoom 1
